import React ,{useEffect} from 'react';
import * as selectors from '../selectors'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {UserProfileConnected} from '../actions'
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import styles from './userProfile.module.scss'
import {userProfileColumns, userRoleColumns} from '../constants'

export const UserProfile = (props) => {
    const { UserProfileConnected } = props;
    useEffect(() => {
        UserProfileConnected();
    }, [UserProfileConnected]);

    let success = props.statusSql;

    return ( <div>
        <div className={ styles.idGrid }>        
            <GridHeader title="User Profile"/>
            <div className={ styles.gridContainer }>
                <Grid
                    columns={ userProfileColumns }
                    defaultColumnSpacing={ 2 }
                    rows={ props.rowsForUserProfile }
                    loading={ props.loading }                    
                />
            
            </div>            
        </div>
        <div className={ styles.idGrid }>
            <GridHeader title="User Roles" />
        <div className={ styles.gridContainer }>
            <Grid
                columns={ userRoleColumns }
                defaultColumnSpacing={ 2 }
                rows={ props.userRoles }
                loading={ props.loading }                            
            />
    
        </div>
    </div>
    </div>); 
}

UserProfile.propTypes = {    
};

UserProfile.defaultProps = {
    styles: styles,    

};

const mapDispatchToProps = {
    UserProfileConnected
};

const mapStateToProps = state => ( 
    {
        rowsForUserProfile: selectors.getRowsUserProfile(state),
        userRoles: state.settings.userRole,
        loading: state.settings.loadingUserProfile,
        lastUpdated: selectors.getLastUpdatedUserProfile(state)
    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserProfile));
